import script from "./MooringMarker.vue?vue&type=script&lang=ts&setup=true"
export * from "./MooringMarker.vue?vue&type=script&lang=ts&setup=true"

import "./MooringMarker.vue?vue&type=style&index=0&id=fff20f44&lang=css"

const __exports__ = script;

export default __exports__